import styled from 'styled-components';
import { mq, getSpace, px2rem } from '../../../stylesheets/tools';

const StyledAnchorMenu = styled.div`
  .anchorMenu__card {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 50;
    max-width: ${px2rem('360px')};
    width: 100%;
    transform: translateX(100%);
    transition: .25s ease-in-out;
    
    ${mq('m')} {
      max-width: ${px2rem('460px')};
    }
    
    &.anchorMenu__card--open {
      transform: translateX(0);
    }
  }
  .anchorMenu__nav {
    background-color: transparent;
    background-image: linear-gradient(180deg,#000,#000),linear-gradient(225deg,#000,#000), linear-gradient(0deg,#000,#000),linear-gradient(90deg,#000,#000), linear-gradient(135deg,transparent 7px,#000 7px,#000 9px,transparent 9px);
    background-position: top right,top right,bottom left,bottom left,top left;
    background-size: calc(100% - 10px) 2px,2px 100%,100% 2px,2px calc(100% - 10px),15px 15px;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    position: relative;
    
    &:before {
      content: '';
      z-index: -1;
      clip-path: polygon(10px 0,100% 0,100% 100%,0 100%,0 10px);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: white;
    }
  }

  .anchorMenu__back-to-top {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 60;
    color: #000;
    background-color: #fff;
    border: 2px solid #000;
    height: ${px2rem('70px')};
    min-width: ${px2rem('70px')};
    padding: 0 ${px2rem('20px')};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${px2rem('24px')};

    .anchorMenu__back-to-top-title {
      display: none;
      
      ${mq('m')} {
        display: block;
        max-width: ${px2rem('120px')};
        margin-bottom: 0px;
        text-align: left;
      }
    }
  }

  .anchorMenu__buttons {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 60;
    color: #000;
    background-color: #fff;
    border: 2px solid #000;
    padding: 0 ${px2rem('16px')};
    height: ${px2rem('70px')};
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;
    width: ${px2rem('96px')};
    
    ${mq('m')} {
      padding: 0 ${px2rem('26px')};
      height: ${px2rem('70px')};
      width: ${px2rem('120px')};
    }
  }

  .anchorMenu__buttons--active {
    background-color: #000;
    color: #fff;
  }

  .anchorMenu__close-button {
    display: flex;
    height: ${px2rem('20px')};
    width: ${px2rem('20px')};

    ${mq('m')} {
      height: ${px2rem('24px')};
      width: ${px2rem('24px')};
    }

    svg {
      height: 100%;
    }
  }
  
  .anchorMenu__burger-button {
    height: ${px2rem('24px')};
    width: ${px2rem('24px')};
    display: flex;
  
    ${mq('m')} {
      height: ${px2rem('28px')};
      width: ${px2rem('28px')};
    }

    svg {
      height: 100%;
    }
  }

  .anchorMenu__nav {
    padding: ${px2rem('20px')} ${px2rem('20px')} ${px2rem('80px')} ${px2rem('20px')};
  }

  .anchorMenu__headline {
    display: block;
    margin-bottom: ${getSpace('xs')}
    color: #9D9D9D;
  }

  .anchorMenu__items {
    display: flex; 
    flex-direction: column;
    gap: 10px;
  }

  .anchorMenu__item {
    display: flex;
    gap: ${px2rem('10px')};
    color: #000;
    text-align: left;

    svg {
      flex: none;
    }
  }
`;

export default StyledAnchorMenu;
